import React from 'react';
import { L } from '../../../abp/utils';
import { Resource, ResourceApi } from '../../../client/http';
import ItemRenderComponent from '../../../common/components/item-render/ItemRenderComponent';
import ApiComboBox from '../../../common/forms/validation/controls/api-combo-box/ApiComboBox';
import useApi from '../../../common/hooks/useApi';
import { FIELD_DESIGNATION } from '../../../data/field-constants/GeneralConstants';
import { ResourceSelectionProps } from '../../../module-components/service-entities/ServiceEntityControlProps';
import { Settings_ProviderName, Settings_ServiceConnectionId } from '../../../util/SettingNames';

const ResourceSelection: React.FC<ResourceSelectionProps> = ({ fetchFromAllProviders, selectedItem, itemRenderFields, data,
    name, title, placeholder, filterable, filterFields, dataItemKey, textField, itemRender, content, footer, ...props }) => {

    const apiResult = useApi<Resource, ResourceApi>(c => new ResourceApi(c), c => c.apiServicesAppResourceGetAllGet(fetchFromAllProviders ? undefined :
        abp.setting.get(Settings_ProviderName), fetchFromAllProviders ? undefined : abp.setting.getInt(Settings_ServiceConnectionId)));

    return <ApiComboBox apiResult={data ? [data, undefined, undefined, () => { }, undefined] : apiResult} name={name} filterable={filterable ?? true} dataItemKey={dataItemKey ?? 'id'}
        textField={textField ?? FIELD_DESIGNATION} placeholder={placeholder ?? L('Resource')}
        itemRender={(li, props) => <ItemRenderComponent li={li} itemProps={props} fields={itemRenderFields ?? [FIELD_DESIGNATION, 'firstName']} />}
        footer={footer} content={content} popupSettings={{width:'min(400px,50vw)'}}
        filterFields={filterFields ?? [FIELD_DESIGNATION, 'firstName']} {...props} />
}

export default ResourceSelection;